import { Grid, styled, Theme, Typography, useMediaQuery } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useRef } from 'react';
import { getCgBreakpointDown } from '../utils';

const useStyles = makeStyles((theme) => ({
  citationTypeText: {
    fontWeight: 600,
    fontSize: '24px',
  },
  citationTypeContainer: {
    marginTop: '70px',
    width: '100%',
    // [theme.breakpoints.down(1030)]: {
    //   marginTop: '100px',
    // },
  },
  exampleContainer: {
    marginTop: '60px',
  },
  seprator: {
    // [theme.breakpoints.down(1030)]: {
    //   width: '100%',
    //   height: '10px',
    // },
  },
  infoTextContainer: {
    position: 'absolute',
    top: '-50px',
    left: '-21px',
    width: '160px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '& svg': {
      marginRight: '25px',
    },
  },
  infoTextContainerColumnReverse: {
    // [theme.breakpoints.down(1030)]: {
    //   flexDirection: 'column-reverse',
    // },
  },
  infoTextContainerApaTitle: {
    left: '33px',
    // left: '76px',
    '& svg': {
      marginRight: '-15px',
    },
    // [theme.breakpoints.down(1030)]: {
    //   top: '35px',
    //   '& svg': {
    //     marginRight: '0px',
    //     transform: 'rotate(150deg) !important',
    //   },
    // },
    // [theme.breakpoints.down(768)]: {
    //   left: '200px',
    //   top: '-85px',
    //   '& svg': {
    //     marginRight: '0px',
    //     transform: 'rotate(10deg) !important',
    //   },
    // },
  },
  infoTextContainerApaPublisher: {
    left: '73px',
    // [theme.breakpoints.down(1030)]: {
    //   top: '35px',
    //   left: '85px',
    //   '& p': {
    //     marginRight: '25px',
    //     left: '76px',
    //   },
    //   '& svg': {
    //     transform: 'rotate(170deg) !important',
    //   },
    // },
  },
  infoTextContainerApaAuthor: {
    '& svg': {
      marginLeft: '30px',
    },
    // [theme.breakpoints.down(1030)]: {
    //   '& svg': {
    //     transform: 'rotate(-38deg)',
    //   },
    // },
  },
  infoTextContainerMlaPublisher: {
    left: '-50px',
    // left: '34px',
    // [theme.breakpoints.down(1030)]: {
    //   top: '34px',
    // },
    // [theme.breakpoints.down(768)]: {
    //   top: '34px',
    //   left: '-34px',
    //   '& svg': {
    //     transform: 'rotate(180deg)',
    //   },
    // },
  },
  infoTextContainerMlaDate: {
    left: '-38px',
    // left: '-55px',
    '& svg': {
      // marginRight: '-15px',
    },
    // [theme.breakpoints.down(1030)]: {
    //   top: '35px',
    //   '& p': {
    //     position: 'relative',
    //     left: '15px',
    //   },
    // },
    // [theme.breakpoints.down(768)]: {
    //   '& svg': {
    //     transform: 'rotate(140deg)',
    //   },
    // },
  },
  infoTextContainerCsPublisher: {
    left: '4px',
    // left: '34px',
    width: '225px',
    '& svg': {
      marginRight: '-15px',
      // marginRight: '-50px',
    },
    // [theme.breakpoints.down(1030)]: {
    //   top: '35px',
    // },
    // [theme.breakpoints.down(768)]: {
    //   left: '-80px',
    //   top: '35px',
    //   '& svg': {
    //     transform: 'rotate(180deg)',
    //   },
    // },
  },
  infoTextContainerCsDate: {
    left: '-66px',
    // left: '-84px',
    '& svg': {
      marginRight: '-13px',
      // marginRight: '-70px',
    },
    // [theme.breakpoints.down(1030)]: {
    //   top: '35px',
    //   '& p': {
    //     position: 'relative',
    //     left: '40px',
    //   },
    // },
    // [theme.breakpoints.down(768)]: {
    //   left: '-50px',
    //   '& svg': {
    //     transform: 'rotate(125deg)',
    //   },
    // },
  },
  infoTextContainerApaYear: {
    // [theme.breakpoints.down(1030)]: {
    //   '& p': {
    //     position: 'relative',
    //     right: '20px',
    //   },
    //   '& svg': {
    //     marginRight: '50px',
    //   },
    // },
  },
  infoTextContainerMlaAuthor: {
    left: '12px',
    '& svg': {
      marginLeft: '30px',
    },
  },
  infoTextContainerMlaTitle: {
    '& svg': {
      marginRight: '-15px',
    },
  },
  infoTextContainerCsAuthor: {
    '& svg': {
      marginLeft: '30px',
    },
  },
  infoTextContainerCsTitle: {
    left: '31px',
    '& svg': {
      // marginRight: '-15px',
    },
    // [theme.breakpoints.down(768)]: {
    //   left: '100px',
    //   top: '-85px',
    //   '& svg': {
    //     marginRight: '0px',
    //     transform: 'rotate(-42deg) !important',
    //   },
    // },
  },
  marginBottomForSmall: {
    // [theme.breakpoints.down(1030)]: {
    //   marginBottom: '40px',
    // },
  },
}));

const useFullTextCitationHelperTextStyles = makeStyles((theme) => ({
  exampleTopText: {
    fontWeight: 600,
    fontSize: '16px',
  },
  exampleBottomText: {
    fontWeight: 600,
    fontSize: '22px',
    [theme.breakpoints.down(768)]: {
      fontSize: '18px',
    },
    borderRadius: '5px',
    padding: '0px 2px',
  },
  root: {
    position: 'relative',
    marginRight: '1px',
  },
}));

const FullTextCitationHelperText = (props: { [key: string]: string }) => {
  const classes = useFullTextCitationHelperTextStyles();
  const {
    arrowDirection,
    citationText,
    citationTextColor,
    infoText,
    infoTextColor,
    infoTextContainerClass,
    rootClass,
    fontStyle,
  } = props;
  return (
    <div className={`${classes.root} ${rootClass}`}>
      <Typography
        className={classes.exampleBottomText}
        style={{
          background: citationTextColor,
          fontStyle,
        }}
      >
        {citationText}
      </Typography>
      {infoText && (
        <div className={infoTextContainerClass}>
          <Typography
            className={classes.exampleTopText}
            style={{
              color: infoTextColor,
            }}
          >
            {infoText}
          </Typography>
          <svg
            style={{
              transform: arrowDirection === 'left' ? 'rotate(-42deg)' : undefined,
            }}
            width="11"
            height="23"
            viewBox="0 0 11 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0279 0.835314C10.1189 0.57458 10.404 0.436946 10.6647 0.5279C10.9254 0.618854 11.0631 0.903952 10.9721 1.16469L10.0279 0.835314ZM3.21737 22.9503C2.96869 23.0703 2.66978 22.9661 2.54972 22.7174L0.593353 18.6649C0.473301 18.4162 0.577574 18.1173 0.826255 17.9972C1.07493 17.8772 1.37385 17.9815 1.49391 18.2301L3.2329 21.8323L6.83511 20.0934C7.08379 19.9733 7.38271 20.0776 7.50276 20.3263C7.62281 20.5749 7.51854 20.8739 7.26986 20.9939L3.21737 22.9503ZM10.9721 1.16469L3.4721 22.6647L2.5279 22.3353L10.0279 0.835314L10.9721 1.16469Z"
              fill={infoTextColor}
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export function FullTextCitationEdu() {
  const classes = useStyles();
  const isSmallScreen = useMediaQuery<Theme>((theme) => getCgBreakpointDown(theme));

  return (
    <Grid
      container
      style={{
        padding: `60px ${isSmallScreen ? '0px' : '40px'} 70px`,
      }}
    >
      <Grid
        item
        container
        style={{
          background: '#F4F8FF',
          // opacity: '0.75',
          borderRadius: isSmallScreen ? '0px' : '10px',
        }}
      >
        <Grid
          container
          style={{
            padding: isSmallScreen ? '0px' : '50px',
          }}
        >
          <Grid
            container
            justifyContent="center"
            style={{ marginTop: isSmallScreen ? '50px' : '10px' }}
          >
            <Grid item container justifyContent="center">
              <Typography component="h3" className={classes.citationTypeText}>
                APA Format Example
              </Typography>
            </Grid>

            <Grid item container justifyContent="center" className={classes.exampleContainer}>
              <FullTextCitationHelperText
                arrowDirection="left"
                citationText="Salinger, J. D."
                citationTextColor="#AFDEFF"
                infoText="Author"
                infoTextColor="#3F88BC"
                infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerApaAuthor}`}
              />

              <FullTextCitationHelperText
                citationText="(1951)."
                citationTextColor="#DA9A39"
                infoText="Year"
                infoTextColor="#DA9A39"
                infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerApaYear}`}
              />

              {isSmallScreen ? (
                <>
                  <FullTextCitationHelperText
                    citationText="The Catcher"
                    citationTextColor="#C6FAD8"
                    fontStyle="italic"
                    // infoText="Title"
                    // infoTextColor="#36A159"
                    // arrowDirection="left"
                    infoTextContainerClass={`${classes.infoTextContainer}${classes.infoTextContainerApaTitle}`}
                  />

                  <Grid className={classes.seprator} />

                  <FullTextCitationHelperText
                    citationText="in the Rye."
                    fontStyle="italic"
                    citationTextColor="#C6FAD8"
                    infoText="Title"
                    infoTextColor="#36A159"
                    arrowDirection="left"
                    infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerApaTitle}`}
                  />
                </>
              ) : (
                <>
                  <Grid className={classes.seprator} />
                  <FullTextCitationHelperText
                    citationText="The Catcher in the Rye."
                    fontStyle="italic"
                    citationTextColor="#C6FAD8"
                    infoText="Title"
                    infoTextColor="#36A159"
                    arrowDirection="left"
                    infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerApaTitle}`}
                  />
                </>
              )}

              <FullTextCitationHelperText
                citationText="Little, Brown and Company."
                citationTextColor="#FFCEF4"
                infoText="Publisher"
                infoTextColor="#B81E96"
                arrowDirection="left"
                infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerApaPublisher}`}
              />
            </Grid>
          </Grid>

          <Grid container className={classes.citationTypeContainer}>
            <Grid item container justifyContent="center">
              <Typography component="h3" className={classes.citationTypeText}>
                MLA Format Example
              </Typography>
            </Grid>

            <Grid container justifyContent="center" className={classes.exampleContainer}>
              <FullTextCitationHelperText
                citationText="Salinger, J. D."
                citationTextColor="#AFDEFF"
                infoText="Author"
                infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerMlaAuthor}`}
                infoTextColor="#3F88BC"
              />

              {isSmallScreen ? (
                <>
                  <FullTextCitationHelperText
                    citationText='"The Catcher"'
                    citationTextColor="#C6FAD8"
                    infoText="Title"
                    infoTextColor="#36A159"
                    arrowDirection="left"
                    infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerMlaTitle}`}
                  />

                  <Grid className={classes.seprator} />

                  <FullTextCitationHelperText
                    citationText='in the Rye."'
                    citationTextColor="#C6FAD8"
                    // infoText="Title"
                    // infoTextColor="#36A159"
                    // arrowDirection="left"
                    // infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerMlaTitle}`}
                  />
                </>
              ) : (
                <>
                  <FullTextCitationHelperText
                    citationText='"The Catcher in the Rye."'
                    citationTextColor="#C6FAD8"
                    infoText="Title"
                    infoTextColor="#36A159"
                    arrowDirection="left"
                    infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerMlaTitle}`}
                  />

                  <Grid className={classes.seprator} />
                </>
              )}

              {isSmallScreen ? (
                <>
                  <FullTextCitationHelperText
                    citationText="Little, Brown"
                    citationTextColor="#FFCEF4"
                    // infoText="Publisher"
                    // infoTextColor="#B81E96"
                    // infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerMlaPublisher}`}
                  />

                  <Grid className={classes.seprator} />

                  <FullTextCitationHelperText
                    citationText="and Company."
                    citationTextColor="#FFCEF4"
                    infoText="Publisher"
                    infoTextColor="#B81E96"
                    infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerMlaPublisher}`}
                  />
                </>
              ) : (
                <FullTextCitationHelperText
                  citationText="Little, Brown and Company."
                  citationTextColor="#FFCEF4"
                  infoText="Publisher"
                  infoTextColor="#B81E96"
                  infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerMlaPublisher}`}
                />
              )}

              <FullTextCitationHelperText
                citationText="(1951)."
                citationTextColor="#DA9A39"
                infoText="Year"
                infoTextColor="#DA9A39"
                infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerMlaDate}`}
              />
            </Grid>
          </Grid>

          <Grid
            container
            className={classes.citationTypeContainer}
            style={{ marginBottom: isSmallScreen ? '100px' : '' }}
          >
            <Grid item container justifyContent="center">
              <Typography component="h3" className={classes.citationTypeText}>
                Chicago Style Example
              </Typography>
            </Grid>

            <Grid container justifyContent="center" className={classes.exampleContainer}>
              <FullTextCitationHelperText
                citationText="Salinger, J. D."
                citationTextColor="#AFDEFF"
                infoText="Author"
                infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerCsAuthor}`}
                infoTextColor="#3F88BC"
              />

              {isSmallScreen ? (
                <>
                  <FullTextCitationHelperText
                    citationText="The Catcher in"
                    fontStyle="italic"
                    citationTextColor="#C6FAD8"
                    // infoText="Title"
                    // infoTextColor="#36A159"
                    // arrowDirection="left"
                    // infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerCsTitle}`}
                  />

                  <Grid className={classes.seprator} />

                  <FullTextCitationHelperText
                    citationText="the Rye."
                    fontStyle="italic"
                    citationTextColor="#C6FAD8"
                    infoText="Title"
                    infoTextColor="#36A159"
                    // arrowDirection="left"
                    infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerCsTitle}`}
                  />
                </>
              ) : (
                <>
                  <FullTextCitationHelperText
                    citationText="The Catcher in the Rye."
                    fontStyle="italic"
                    citationTextColor="#C6FAD8"
                    infoText="Title"
                    infoTextColor="#36A159"
                    arrowDirection="left"
                    infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerCsTitle}`}
                  />
                  <Grid className={classes.seprator} />
                </>
              )}

              {isSmallScreen ? (
                <>
                  <FullTextCitationHelperText
                    citationText="Boston: Little, Brown"
                    citationTextColor="#FFCEF4"
                    // infoText="City of publication: Publisher"
                    // infoTextColor="#B81E96"
                    // infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerCsPublisher}`}
                  />
                  <Grid className={classes.seprator} />
                  <FullTextCitationHelperText
                    citationText="and Company,"
                    citationTextColor="#FFCEF4"
                    infoText="City of publication: Publisher"
                    infoTextColor="#B81E96"
                    infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerCsPublisher}`}
                  />
                </>
              ) : (
                <FullTextCitationHelperText
                  citationText="Boston: Little, Brown and Company,"
                  citationTextColor="#FFCEF4"
                  infoText="City of publication: Publisher"
                  infoTextColor="#B81E96"
                  rootClass={classes.marginBottomForSmall}
                  infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerCsPublisher}`}
                />
              )}

              <FullTextCitationHelperText
                arrowDirection={isSmallScreen ? '' : 'left'}
                citationText="(1951)."
                citationTextColor="#DA9A39"
                infoText="Year"
                infoTextColor="#DA9A39"
                infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerCsDate}`}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

const fontProps = {
  component: 'h3',
  fontSize: '24px',
  fontWeight: 600,
};

const StyledGrid = styled(Grid)`
  .block-parent {
    display: flex;
    flex-direction: column;
    min-width: 780px;
  }

  .block {
    display: flex;
    margin-bottom: 60px;
    justify-content: center;
  }
`;

export function FullTextCitationEduOverflow() {
  const classes = useStyles();
  const container = useRef<HTMLDivElement>(null);
  const firstTitle = useRef<HTMLElement>(null);

  useEffect(() => {
    if (
      container.current &&
      container.current.scrollWidth > container.current.offsetWidth &&
      firstTitle.current
    ) {
      container.current.scrollLeft =
        firstTitle.current.offsetLeft / 2 + container.current.offsetLeft;
    }
  }, [firstTitle.current]);

  return (
    <StyledGrid
      container
      mt="60px"
      px="16px"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      xs={12}
      overflow="auto"
      ref={container}
    >
      <div className="block-parent">
        <div className="block">
          <Typography {...fontProps} ref={firstTitle}>
            APA Format Example
          </Typography>
        </div>

        <div className="block">
          <FullTextCitationHelperText
            citationText="Salinger, J. D."
            citationTextColor="#6CBCF5"
            infoText="Author"
            infoTextColor="#247FC1"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerApaAuthor}`}
            arrowDirection="left"
          />

          <FullTextCitationHelperText
            citationText="(1951)."
            citationTextColor="#F3B351"
            infoText="Year"
            infoTextColor="#B27313"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerApaYear}`}
          />

          <FullTextCitationHelperText
            citationText="The catcher in the rye."
            citationTextColor="#77D297"
            infoText="Title"
            infoTextColor="#2A7844"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerApaTitle}`}
            fontStyle="italic"
            arrowDirection="left"
          />

          <FullTextCitationHelperText
            citationText="Little, Brown and Company."
            citationTextColor="#D794F6"
            infoText="Publisher"
            infoTextColor="#893FA4"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerApaPublisher}`}
            arrowDirection="left"
          />
        </div>

        <div className="block">
          <Typography {...fontProps}>MLA Format Example</Typography>
        </div>

        <div className="block">
          <FullTextCitationHelperText
            citationText="Corey, James S. A."
            citationTextColor="#6CBCF5"
            infoText="Author"
            infoTextColor="#247FC1"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerMlaAuthor}`}
          />

          <FullTextCitationHelperText
            citationText="Leviathan Wakes."
            citationTextColor="#77D297"
            infoText="Title"
            infoTextColor="#2A7844"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerMlaTitle}`}
            fontStyle="italic"
            arrowDirection="left"
          />

          <FullTextCitationHelperText
            citationText="Orbit US,"
            citationTextColor="#D794F6"
            infoText="Publisher"
            infoTextColor="#893FA4"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerMlaPublisher}`}
            arrowDirection="left"
          />

          <FullTextCitationHelperText
            citationText="2011."
            citationTextColor="#F3B351"
            infoText="Year"
            infoTextColor="#B27313"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerMlaDate}`}
          />
        </div>

        <div className="block">
          <Typography {...fontProps}>Chicago Style Example</Typography>
        </div>

        <div className="block">
          <FullTextCitationHelperText
            citationText="Corey, James S. A."
            citationTextColor="#6CBCF5"
            infoText="Author"
            infoTextColor="#247FC1"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerCsAuthor}`}
          />

          <FullTextCitationHelperText
            citationText="2011."
            citationTextColor="#F3B351"
            infoText="Year"
            infoTextColor="#B27313"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerCsDate}`}
            arrowDirection="left"
          />

          <FullTextCitationHelperText
            citationText="Leviathan Wakes."
            citationTextColor="#77D297"
            infoText="Title"
            infoTextColor="#2A7844"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerCsTitle}`}
            fontStyle="italic"
            rootClass={classes.marginBottomForSmall}
          />

          <FullTextCitationHelperText
            citationText="New York: Orbit US."
            citationTextColor="#D794F6"
            infoText="City of publication: Publisher"
            infoTextColor="#893FA4"
            infoTextContainerClass={`${classes.infoTextContainer} ${classes.infoTextContainerColumnReverse} ${classes.infoTextContainerCsPublisher}`}
          />
        </div>
      </div>
    </StyledGrid>
  );
}
